import { CloseIcon } from "@chakra-ui/icons";
import {
  BaseEdge,
  EdgeLabelRenderer,
  getBezierPath,
  type EdgeProps
} from "@xyflow/react";
import { useState } from "react";

interface DeletableEdgeData {
  onDelete?: (edgeId: string) => void;
}

export function DeletableEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style,
  markerEnd,
  selected,
  data
}: EdgeProps & { data?: DeletableEdgeData }) {
  const [isHovered, setIsHovered] = useState(false);
  const canDelete = !!data?.onDelete;
  const showBtn = isHovered || selected;

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition
  });

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      {/* Transparent wide hit-area so mouse events fire on the edge line */}
      <path
        d={edgePath}
        fill="none"
        stroke="transparent"
        strokeWidth={20}
        // onMouseEnter={() => setIsHovered(true)}
        // onMouseLeave={() => setIsHovered(false)}
      />
      <EdgeLabelRenderer>
        <div
          className="nodrag nopan"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: "all",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <button
            disabled={!canDelete}
            onClick={(e) => {
              e.stopPropagation();
              if (!canDelete) return;
              data?.onDelete?.(id);
            }}
            style={{
              width: 22,
              height: 22,
              borderRadius: "50%",
              background: "#EF4444",
              border: "2px solid #fff",
              color: "#fff",
              cursor: canDelete ? "pointer" : "not-allowed",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              opacity: canDelete ? (showBtn ? 1 : 0.3) : 0.2,
              transition: "opacity .15s ease"
            }}
          >
            <CloseIcon w="9px" h="9px" />
          </button>
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
